interface IProps {
  color?: string;
}

const HorizontalDivider: React.FC<IProps> = () => {
  return <div className="border-b-2 border-gray-500 w-full my-4"></div>;
};

export default HorizontalDivider;
